import { createContext, useContext } from "react";
/**
 * Context for assets
 */
export const AssetsContext = createContext({
    assetUrl: "",
});
/**
 * Hook to create asset URLs
 * @returns An object with a createAssetUrl function for creating asset URLs
 */
export const useWebAssets = () => {
    const { assetUrl } = useContext(AssetsContext);
    const createAssetUrl = (type, name) => {
        return `${assetUrl.replace(/\/$/, "")}/${type}s/${name}`;
    };
    return {
        createAssetUrl,
    };
};
//# sourceMappingURL=useWebAssets.js.map